<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'sendEmailMessage.title' | translate }}</h4>
      <p class="mb-0">{{ 'sendEmailMessage.text' | translate: currentObject }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #emailMessageForm="ngForm" (ngSubmit)="onSubmit(emailMessageForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'sendEmailMessage.detailsHeader' | translate }}
            </h4>

            <!-- EmailMessageId -->
            <div class="form-group">
              <label for="EmailMessageId">{{ 'sendEmailMessage.emailMessageIdFieldLabel' | translate }}</label>
              <input class="form-control" name="EmailMessageId" #EmailMessageId="ngModel"
                     [(ngModel)]="currentObject.EmailMessageId"
                     placeholder="{{'sendEmailMessage.emailMessageIdFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- RecipientEmailAddress -->
            <div class="form-group">
              <label
                for="RecipientEmailAddress">{{ 'sendEmailMessage.recipientEmailAddressFieldLabel' | translate }}</label>
              <input type="text" class="form-control" name="RecipientEmailAddress" id="RecipientEmailAddress"
                     #RecipientEmailAddress="ngModel" [(ngModel)]="currentObject.RecipientEmailAddress"
                     placeholder="{{'sendEmailMessage.recipientEmailAddressFieldPlaceHolder' | translate}}" required
                     email ngModel [ngModelOptions]="{updateOn: 'blur'}"
                     pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"/>
              <small class="form-text text-muted danger"
                     *ngIf="!RecipientEmailAddress.valid && (RecipientEmailAddress.dirty || RecipientEmailAddress.touched)">Please
                enter a valid emailaddress.</small>
            </div>

            <!-- Subject -->
            <div class="form-group">
              <label for="Subject">{{ 'sendEmailMessage.subjectFieldLabel' | translate }}</label>
              <input class="form-control" name="Subject" #Subject="ngModel" [(ngModel)]="currentObject.Subject"
                     placeholder="{{'sendEmailMessage.subjectFieldPlaceHolder' | translate}}"
                     required>
            </div>

            <!-- Body -->
            <div class="form-group">
              <label for="Body">{{ 'sendEmailMessage.bodyFieldLabel' | translate }}</label>
              <textarea class="form-control" name="Body" #Body="ngModel" [(ngModel)]="currentObject.Body"
                        placeholder="{{'sendEmailMessage.bodyFieldPlaceHolder' | translate}}"
                        rows="5" required></textarea>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-raised btn-raised btn-warning mr-1" type="button"
                    (click)="resetForm(emailMessageForm)">
              <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
            </button>
            <button [disabled]="!emailMessageForm.valid" class="btn btn-raised btn-raised btn-primary mr-1"
                    type="submit">
              <i
                class="ft-check-square"></i> {{ hasDesktopView ? ('buttons.saveAndSendText' | translate) : ('buttons.sendText' | translate) }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
